/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Field, FieldArray, Form, Formik } from 'formik';
import 'react-day-picker/dist/style.css';

import { Layout } from 'components';
import { Button, DateRangePicker } from 'components/index';
import { Col, Row } from 'components/Grid';
import { InputField, SelectField, } from 'components/Form';
import Icon from 'components/Icon';
import Loader from 'components/Loader';
import DialogComponent from "components/Dialog";
import Checkbox from 'components/Form/CheckBox';
import { FitinsurAPI, MessageCenter } from 'utils';
import Colors from 'constants/Colors';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import {
  CalendarContainer,
  Content,
  DialogCancel,
  DialogConfirm,
  InlineLabel,
  Line,
  LoadContainer,
  Circle,
  DialogSelect,
  RowFilterIcon,
  FilterContainer,
  FilterSearchContainer,
  ColIcon,
  RowFilter,
  CheckBoxColumn,
  FilterColumn,
  MobileLabel,
  RowFilterOrder,
  RowGrid,
  CustomField,
  ContentAlert,
  FilterLabel,
  TooltipCard,
  TooltipText,
  TooltipBox,
} from './styles';
import { GridColumnTitle } from 'components/Form/styles';
import HasPermission from 'components/HasPermission/index';
import MultiSelectField from 'components/Form/MultiSelectField';
import _ from 'lodash';
import EndorsementRow from './EndorsementRows/index';
import NotesModalV2 from 'components/NotesModalV2/index';
import CacheManager from 'utils/src/cache-manager';
import useWindowScroll from 'services/useWindowScroll';
import ListEnquiryButtons from 'components/ListEnquiryButtons';
import { ResponsiveTable, ComboBox, Label} from '@fitinsur/components';

export default function PolicyPage(props) {
  const cache = new CacheManager();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();
  const location = useLocation();
  let scrollUpdate = useWindowScroll();
  const formik = useRef();
  const endorsementFormik = useRef();
  const [sortBy, setSortBy] = useState({ key: null, direction: null });
  const [showCalendar, setShowCalendar] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [statusList, setStatusList] = useState([])
  const [endorsementsStatus, setEndorsementsStatus] = useState([]);
  const [selectedOperationId, setSelectedOperationId] = useState(null);
  const [selectedEndorsmentType, setSelectedEndorsmentType] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [showEndorsement, setShowEndorsement] = useState([]);
  const [endorsementToShow, setEndorsementToShow] = useState([]);
  const [brokerOptions, setBrokerOptions] = useState([]);
  const [typeDialog, setTypeDialog] = useState(null);
  const [filtersList, setFiltersList] = useState([]);
  const [isAbleEdit, setIsAbleEdit] = useState(false);
  const [isAbleDelete, setIsAbleDelete] = useState(false);
  const [isAbleCreate, setIsAbleCreate] = useState(false);
  const [filterOptions, setFilterOptions] = useState([]);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    icon: "times-circle",
    args: null,
  });
  const isClient = authContext.enumProfile == 1 ? true : false;
  const [showPoliciesNotesModal, setShowPoliciesNotesModal] = useState(false);
  const [notesModalProps, setNotesModalProps] = useState(null);
  const [tooltips, setTooltips] = useState([]);
  const [offices, setOffices] = useState([]);
  const [products, setProducts] = useState([]);
  const [currentOperation, setCurrentOperation] = useState(null);

  const region = authContext.region === 'en-GB' ? 'en' : 'en';

  const initialValues = {
    filter: {
      name: "",
      reference: "",
      client: "",
      obligor: "",
      broker: "",
      status: "",
      endorsementStatus: "",
      idAction: "",
      leadingOffice: "",
      products: "",
      nextPayment: {
        from: undefined,
        to: undefined,
      }
    },
    endorsements: data
  };

  const [filterSelected, setFilterSelected] = useState(initialValues.filter);

  const handleColorLabel = (item) => {
    if (item.isRejected) return Colors.GRAY[3];
    else if (item.requireAttention) return Colors.RED;
    else if (item.isApproved) return Colors.GRAY[0];
    else if (item.mediationFinished) return Colors.PRIMARY1;
    else return Colors.GRAY[0];
  }

  const columnsFilter = [
    {
      title: "REFERENCE",
      value: "reference",
    },
    {
      title: "OFFICE",
      value: "leadingOffice",
    },
    {
      title: "CLIENT",
      value: "client",
    },
    {
      title: "MAIN PARTY",
      value: "obligor",
    },
    {
      title: "BROKER",
      value: "broker",
    },
    {
      title: "NEXT SDD",
      value: "nextPayment",
    },
    {
      title: "NEXT SDD",
      value: "status",
    }
  ];

  const columns = [
    {
      title: "REFERENCE",
      key: "reference",
      sortKey: "reference",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (item, index, isChildRow) => {
        if (isChildRow) return <div style={{ marginLeft: 15 }}>
          <InlineLabel>
            Reference
          </InlineLabel>
          <Label color={handleColorLabel(item)} fontSize={13}>
            <Circle>E</Circle>
            {item.referenceNumber}
          </Label>
        </div>

        return <>
          <InlineLabel>
            Reference
          </InlineLabel>
          <Label color={handleColorLabel(item)} fontSize={13} style={{ display: "inline-flex"}}>
            <Circle>{item.isDeclaration ? 'D' : 'P'}</Circle>
            {item.reference}
            {' '}
            {item.childrenData.length >= 1 && (
              item.showChildRow ?
                <Icon name={"arrowup-large"} onClick={() => setData(data.map(v => (item.idOperation === v.idOperation ? { ...v, showChildRow: false } : v)))} />
                :
                <Icon name={"arrowdown-large"} onClick={() => setData(data.map(v => (item.idOperation === v.idOperation ? { ...v, showChildRow: true } : v)))} />
            )}
          </Label>
        </>
      }
    },
    {
      title: "END. REF.",
      key: "endorsementReference",
      minWidth: 10,
      maxWidth: 10,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "OFFICE",
      key: "leadingOffice",
      sortKey: "leadingOffice",
      minWidth: 10,
      maxWidth: 10,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "CLIENT",
      key: "client",
      sortKey: "client",
      minWidth: 18,
      maxWidth: 18,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "MAIN PARTY",
      key: "projectName|obligor",
      sortKey: "obligor",
      minWidth: 18,
      maxWidth: 18,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "BROKER",
      key: "nmBroker",
      sortKey: 'orderBroker',
      minWidth: 14,
      maxWidth: 14,
      component: (listItem) => <Field
        onChange={(a) => {
          let obj = { ...listItem };
          obj.newValue = a;
          selectBroker(obj);
        }}
        style={{ width: '80%' }}
        name={`${listItem.idOperation}-nmBroker`}
        placeholder={listItem?.broker || listItem.nmBroker || "SELECT BROKER"}
        component={ComboBox}
        topReduce
        placeholderColor={handleColorLabel(listItem)}
        options={listItem.listBrokers}
        list={true}
      />
    },
    {
      title: "NEXT SDD",
      key: "nextPayment",
      sortKey: "nextPayment",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "STATUS",
      key: "status",
      minWidth: 18,
      maxWidth: 18,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "ACTION",
      key: "action",
      minWidth: 14,
      maxWidth: 14,
      paddingRight: 40,
      component: (listItem) => <ListEnquiryButtons
        editRoute={checkOperationRoute}
        listItem={listItem}
        idOperation={listItem.idOperation}
        editPermission={props.permissions.POLICIES_EDIT}
        createPermission={props.permissions.POLICIES_CREATE_ENDORSEMENT}
        setCurrentOperation={setCurrentOperation}
        authContextToken={authContext?.token}
        iconTooltips={tooltips}
        toDocument={() => history.push(`/broking/document-management/${listItem.idOperation}`)}
        createEndorsementPermission={props.permissions.POLICIES_CREATE_ENDORSEMENT}
        newEndorsement={newEndorsement}
        flexWrap="nowrap"
        width={100}
        icons={['edit', 'folder', 'note', 'endrosement', 'update-schedule']}
      />
    },
  ];

  const endorsementsTypes = [
    {
      label: "Anniversary: Premium Pre-Agreed",
      value: "pre-agreed",
    },
    {
      label: "Anniversary: Premium Not Pre-Agreed",
      value: "not-pre-agreed"
    },
    {
      label: "Adjustments & Corrections",
      value: "adjustments-and-corrections"
    },
    {
      label: "Client Change",
      value: "client-change"
    },
    {
      label: "Risk Market Changes",
      value: "market-changes"
    },
    {
      label: "Declaration",
      value: "declaration"
    },
    {
      label: "Cancellation",
      value: "cancellation"
    },
    {
      label: "Off-Risk",
      value: "off-risk"
    },
    {
      label: "Policy Extension Endorsement",
      value: "policy-extension"
    }
  ];
  
  const selectBroker = (args) => {
    setTypeDialog('changeBroker');
    setDialog({
      visible: true,
      title: 'Attention',
      icon: 'exclamation',
      args,
    });
  }

  const newEndorsement = (idOperation) => {
    setSelectedOperationId(idOperation);
    setSelectedEndorsmentType(null);

    setDialog({
      visible: true,
      title: 'SELECT ENDORSEMENT TYPE',
      icon: 'exclamation',
      args: null
    })
  }

  const deleteFilter = () => {
    if (filterSelected.filterName) {
      setTypeDialog('deleteFilter');
      setDialog({
        visible: true,
        title: 'REMOVE FILTER',
        icon: 'exclamation',
        args: null
      })
    }
  }

  const handleCreateEndorsement = () => {
    fitinsur.setAuthToken(authContext.token);
    loading.start();

    setDialog({ visible: false, title: null, icon: null, args: null })

    fitinsur.requestCreateEndorsement(selectedOperationId, selectedEndorsmentType)
      .then(response => response.json())
      .then(data => {
        loading.stop();
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        const { idOperation, idProduct } = data.ret_value;

        switch (selectedEndorsmentType) {
          case "pre-agreed":
            return history.push(`/broking/payment-pack-configuration/${idOperation}`);
          case "off-risk":
            return history.push(`/broking/off-risk-edit/${idOperation}`);
          case "not-pre-agreed":
            return history.push(`/broking/market-composition/${idOperation}`);
          case "cancellation":
            return history.push(`/broking/market-composition/${idOperation}`);
          case "declaration":
            return history.push(`/create-enquirity/16/${idOperation}`);
          case "adjustments-and-corrections":
            return history.push(`/edit-enquirity/${idProduct || 12}/${idOperation}`, { disabled: false });
          case "market-changes":
            return history.push(`/edit-enquirity/${idProduct || 12}/${idOperation}`, { disabled: false });
          case "policy-extension":
            return history.push(`/broking/policy-extension-edit/${idOperation}`);
          case "client-change":
            return history.push(`/edit-enquirity/${idProduct || 12}/${idOperation}`, { disabled: false });
          default:
        }
      }).catch((error) => {
        loading.stop();
        mc.error("Failed to create endorsement\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  }

  const checkOperationRouteEnquiry = (res) => {
    let route = "";
    const { idOperationParent, idProduct, idOperation, idNavigation } = res.ret_value;
    // eslint-disable-next-line default-case
    switch (idNavigation) {
      case 1:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
      case 2:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
      case 3:
        route = `/broking/approval-nbi/${idOperation}`;
        break;
      case 4:
        if (idProduct == "16") {
          route = `/broking/select-markets/${idOperation}/${idProduct}`;
        } else {
          route = `/broking/select-markets/${idOperation}`;
        }
        break;
      case 5:
        route = `/broking/contacts-selection/${idOperation}`;
        break;
      case 6:
        route = `/broking/nbi-request/${idOperation}`;
        break;
      case 7:
        route = `/broking/send-nbi-request/${idOperation}`;
        break;
      case 8:
        route = `/broking/market-selection/${idOperation}`;
        break;
      case 9:
        route = `/broking/document-nbi-status/${idOperation}`;
        break;
      case 10:
        route = `/broking/approval-nbi-cv/${idOperation}`;
        break;
      case 11:
        route = `/broking/nbi-request-cv/${idOperation}`;
        break;
      case 12:
        route = `/broking/market-composition/${idOperation}`;
        break;
      case 13:
        route = `/broking/policy-pack-approval/${idOperation}`;
        break;
      case 14:
        route = `/broking/approval-policy-pack/${idOperation}`;
        break;
      case 15:
        route = `/broking/send-policy-pack-client/${idOperation}`;
        break;
      case 16:
        route = `/broking/send-approval-pack/${idOperation}`;
        break;
      case 17: //result.ret_value = {idNavigation: 17, dscNavigation: "Order to Bind Sent"};
        route = `/broking/send-order-to-bind/${idOperation}`;
        break;
      case 18: //result.ret_value = {idNavigation: 18, dscNavigation: "Order to Bind Approved"};
        route = `/broking/order-to-bind/${idOperation}`;
        break;
      case 19: //result.ret_value = {idNavigation: 19, dscNavigation: "Order to Bind Rejected"};
        route = `/broking/order-to-bind/${idOperation}`;
        break;
      case 20: //result.ret_value = {idNavigation: 20, dscNavigation: "Stamp Requested"};
        route = `/broking/stamps-status-list/${idOperation}`;
        break;
      case 21: //result.ret_value = {idNavigation: 21, dscNavigation: "Stamp Requested"};
        route = `/broking/payment-pack-send-approval/${idOperation}`;
        break;
      case 22: //result.ret_value = {idNavigation: 22, dscNavigation: "Stamp Requested"};
        route = `/broking/payment-pack-send-client-insurer/${idOperation}`;
        break;
      case 23: //result.ret_value = {idNavigation: 23, dscNavigation: "Stamp Requested"};
        route = `/broking/payment-pack-approval/${idOperation}`;
        break;
      case 99:
        route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
        break;
    }

    if (route) {
      loading.stop();
      history.push(
        {
          pathname: route,
          state: res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { idProduct: idProduct }
        })
    } else {
      mc.error('NAVIGATION NOT DEFINED');
      loading.stop();
    }
  }

  const goToLoginPage = () => history.push('/login');

  const resetFilters = () => {
    formik.current.resetForm(initialValues);
    setPageNumber(1);
    setSortBy({
      key: null,
      direction: null,
    })

    handleFilter(initialValues.filter);
    requestCustomFilterList('reset');
  };

  const handleSortList = (key) => {
    let direction = 'asc';
    if (sortBy.key === key && sortBy.direction === 'asc') {
      direction = 'desc';
    };
    const sort = { key: key, direction: direction }

    setSortBy(sort);
    setPageNumber(1);
    getList(1, sort, `${location.search || '?'}`);
  };

  const nextPage = () => {
    if (pageNumber === totalPages) return;
    let contPage = (pageNumber + 1);

    setPageNumber(contPage);
    if (location.search) {
      getList(contPage, sortBy, location.search)
    } else {
      getList(contPage, sortBy)

    }
  };

  const jsonToQueryString = (json) => {
    const keys = Object.keys(json).filter(key => json[key]);

    return keys
      .map((key, index) => {
        const sufix = index + 1 === keys.length
          ? ''
          : '&'

        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]) + sufix;
      }
      ).join('');
  }

  const handleFilter = (filters) => {
    const formikFilters = formik.current.values.filter;
    let nextPaymentRange = {};

    const { nextPayment, ...rest } = formikFilters;

    if (formikFilters.nextPayment.from && formikFilters.nextPayment.to) {
      nextPaymentRange = {
        nextPaymentFrom: new Date(formikFilters.nextPayment.from).toLocaleDateString('en-US'),
        nextPaymentTo: new Date(formikFilters.nextPayment.to).toLocaleDateString('en-US'),
      }
    }

    if (filters?.nextPayment) {
      nextPaymentRange = {}
      delete filters.nextPayment
    }

    const newRest = {
      ...rest,
      reference: rest.reference.trim(),
      client: rest?.client.trim(),
      obligor: rest?.obligor.trim(),
    }

    const filterObject = {
      ...newRest,
      ...nextPaymentRange,
      ...filters,
    }

    const queryString = jsonToQueryString(filterObject)
    const filterQueryString = `?${queryString}`;

    setPageNumber(1);
    getList(1, {}, filterQueryString)

    if (queryString) {
      localStorage.setItem('policies_filter', filterQueryString)
    } else {
      localStorage.removeItem('policies_filter')
    }
    history.push(`policies${filterQueryString}`)
  }

  const getList = (page = 1, sort = {}, filterQueryString = '?') => {
    loading.start();
    const url = `${filterQueryString}&sortBy=${JSON.stringify(sort)}&page=${page}`;

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetEndorsementsList(url)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          loading.stop();
          return;
        }

        setData(data.ret_value.map(policy => {
          const {
            nmBroker,
            nmObligor,
            projectName,
            nmClient,
            referenceNumber,
            idOperation,
            endorsements,
            nextPayment,
            status,
            canCreateEndorsement,
            idDomPaymentPack,
            idDomPolicyStamp,
            idDomStatusPaymentPack,
            idDomStatusPolicyStamp,
            isDeclaration,
            listBrokers,
            requireAttention,
            leadingOffice,
            idOperationRoot,
            isMasterPolicy,
            showIconUpdatedSchedule
          } = policy;

          const formatListBroker = listBrokers && listBrokers.map(broker => ({
            label: broker.nmPersonBroker,
            value: broker.idPersonUser
          }))

          return {
            isDeclaration,
            reference: referenceNumber,
            client: nmClient,
            obligor: nmObligor,
            broker: nmBroker,
            projectName: projectName,
            status,
            canCreateEndorsement,
            nextPayment: new Date(nextPayment).toLocaleDateString('en-GB'),
            idOperation,
            childrenData: endorsements.map(v => ({ ...v, listBrokers: formatListBroker, obligor: v.nmObligor, client: v.clientName || policy.client })),
            idDomPaymentPack,
            idDomPolicyStamp,
            idDomStatusPaymentPack,
            idDomStatusPolicyStamp,
            listBrokers: formatListBroker || [],
            requireAttention,
            leadingOffice: leadingOffice,
            idOperationRoot,
            isMasterPolicy,
            showIconUpdatedSchedule
          }
        }))

        setTotalPages(data.pagination_control.totalPages);
        setStatusList(data.statusList);
        setOffices(data.offices);
        loading.stop();
      }).catch(() => loading.stop()
      );
  }

  const getEndorsementsStatusList = () => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);

    fitinsur.requestGetEndorsementsStatus()
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        setEndorsementsStatus(data.ret_value)
      }).catch(() => loading.stop())
  }

  const checkOperationRoute = (idOperation) => {
    fitinsur.setAuthToken(authContext.token);
    loading.start();

    fitinsur.requestPolicyNavigation(idOperation).then(x => x.json()).then(res => {
      loading.stop();

      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      let { route, idNavigation } = res.ret_value;

      if (idNavigation) return checkOperationRouteEnquiry(res);

      if (route) {
        history.push({ pathname: route })
      } else {
        mc.error('NAVIGATION NOT DEFINED');
        loading.stop();
      }
    }).catch(() => loading.stop());
  }

  const handleSetFilterFromParams = () => {
    if (location.search) {
      const query = new URLSearchParams(location.search);

      if (query.get('reference')) {
        formik.current?.setFieldValue('filter.reference', query.get('reference'))
      }

      if (query.get('client')) {
        formik.current?.setFieldValue('filter.client', query.get('client'))
      }

      if (query.get('obligor')) {
        formik.current?.setFieldValue('filter.obligor', query.get('obligor'))
      }

      if (query.get('nextPaymentFrom') && query.get('nextPaymentTo')) {
        formik.current?.setFieldValue('filter.nextPayment', {
          from: new Date(query.get('nextPaymentFrom')),
          to: new Date(query.get('nextPaymentTo')),
        })
      }

      if (query.get('status')) {
        let statusIds = query
          .get('status')
          .split(',')
          .map(item => Number(item))

        formik.current?.setFieldValue('filter.status', statusIds)
      }

      if (query.get('idAction')) {
        formik.current?.setFieldValue('idAction', Number(query.get('idAction')))
      }

      if (query.get('broker')) {
        let brokerIds = query
          .get('broker')
          .split(',')
          .map(item => Number(item))

        formik.current?.setFieldValue('filter.broker', brokerIds)
      }

      if (query.get('leadingOffice')) {
        let officesIds = query
          .get('leadingOffice')
          .split(',')
          .map(item => Number(item))

        formik.current?.setFieldValue('filter.leadingOffice', officesIds)
      }

      if (query.get('products')) {
        let productsIds = query
          .get('products')
          .split(',')
          .map(item => Number(item))

        formik.current?.setFieldValue('filter.products', productsIds)
      }
    }
  }

  useEffect(() => {
    const query = new URLSearchParams(location.search);

    if (query.get('endorsementStatus') && endorsementsStatus.length) {
      const selectedStatus = query.get('endorsementStatus')
        .split(",")
        .map(item => Number(item));

      const endorsementStatusSelected = []
      for (const statusId of selectedStatus) {
        const endorsementStatusOptions = endorsementsStatus
          .filter(status => status.value.includes(statusId))
          .map(status => status.value)

        endorsementStatusSelected.push(endorsementStatusOptions)
      }

      const uniqueSelectedStatus = [];
      endorsementStatusSelected.map(status => {
        if (!uniqueSelectedStatus.some(uniqueStatus => _.isEqual(uniqueStatus, status))) {
          uniqueSelectedStatus.push(status);
        }
      })

      formik.current?.setFieldValue('filter.endorsementStatus', uniqueSelectedStatus);

    }
  }, [endorsementsStatus])

  const showRangeDate = () => {
    const from = formik.current?.values?.filter?.nextPayment?.from ? formik.current.values.filter.nextPayment.from.toLocaleDateString('en-GB') : ''
    const to = formik.current?.values?.filter?.nextPayment?.to ? formik.current.values.filter.nextPayment.to.toLocaleDateString('en-GB') : ''

    if (!from && !to) {
      return ''
    }

    return `${from} - ${to}`
  }

  const handleGetPreviusFilter = () => {
    const filterQueryString = localStorage.getItem('policies_filter');

    if (filterQueryString) {
      history.push(`policies${filterQueryString}`)
      getList(1, {}, filterQueryString)

    } else {
      getList()
    }
  }

  const requestBrokerHeaderList = () => {
    fitinsur.requestBrokerHeader()
      .then(data => data.json())
      .then(response => {
        if (response.ret_code === 200) {
          const mappedOpt = response.ret_value.map(data => ({ label: data.nmPersonBroker, value: data.ID_PERSON || data.idPersonUser }));
          setBrokerOptions(mappedOpt);
        } else {
          mc.error("An error happened, please try again.");
        }
      })
  }

  const handleExportEndorsements = async (page = 1, sort = {}, filterQueryString = '?') => {
    let exportList = sessionStorage.getItem('texel-export-list-report');
    let list = [];
    if (exportList) list = JSON.parse(sessionStorage.getItem('texel-export-list-report'))
    let verify = list.length > 0 ? list.filter(item => item.nameList == 'Policy Report') : false;
    if (!verify || verify.length == 0) {
      loading.start();
      setTimeout(() => loading.stop(), 2000);
      const url = `${filterQueryString}&sortBy=${JSON.stringify(sort)}&page=${page}`;

      fitinsur.setAuthToken(authContext.token);
      const document = await fitinsur.exportEndorsements(url).then(x => x.json());
      loading.start();
      setTimeout(() => loading.stop(), 2000);
      if (document.idDocument) {
        list.push({ idDocument: document.idDocument, processing: true, nameList: 'Policy Report' });
        sessionStorage.setItem('texel-export-list-report', JSON.stringify(list));
      }
    } else {
      mc.error("Please, wait policy report be downloaded.");
    }
  }

  const showEndorsementRow = (policy, state) => {
    if (state) {
      showEndorsement.push(policy.idOperation);
      setShowEndorsement(showEndorsement)
      setEndorsementToShow(policy)
    } else {
      setShowEndorsement(showEndorsement.filter(idOperation => idOperation != policy.idOperation))
      setEndorsementToShow({})
    }
  }

  const editCustomFilter = (filter) => {
    if (!filter.filter.name) return mc.error("Filter name must be provided");
    const obj = {
      filterName: filter.filter.name,
      id: filter.filter.id,
      idDomain: 319,
      idDomainApplication: 388,
      filterArgs: {
        reference: filter.filter.reference,
        client: filter.filter.client,
        obligor: filter.filter.obligor,
        broker: filter.filter.broker,
        status: filter.filter.status,
        endorsementStatus: filter.filter.endorsementStatus,
        idAction: filter.filter.idAction,
        leadingOffice: filter.filter.leadingOffice,
        products: filter.filter.products,
        nextPayment: {
          from: filter.filter.nextPayment.from,
          to: filter.filter.nextPayment.to,
        }
      }
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateCustomFilter(obj)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        mc.success("Filter updated successfully")
        setIsAbleEdit(!isAbleEdit)
        requestCustomFilterList('edit')
      })
  }

  const createCustomFilter = (filter) => {
    if (!filter.filter.name) {
      mc.error("Please provide a name");
      return;
    }
    const obj = {
      filterName: filter.filter.name,
      idDomain: 319,
      idDomainApplication: 388,
      filterArgs: {
        reference: filter.filter.reference,
        client: filter.filter.client,
        obligor: filter.filter.obligor,
        broker: filter.filter.broker,
        status: filter.filter.status,
        endorsementStatus: filter.filter.endorsementStatus,
        idAction: filter.filter.idAction,
        leadingOffice: filter.filter.leadingOffice,
        products: filter.filter.products,
        nextPayment: {
          from: filter.filter.nextPayment.from,
          to: filter.filter.nextPayment.to,
        }
      }
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestCreateCustomFilter(obj)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        mc.success("Filter created successfully")
        setIsAbleCreate(!isAbleCreate)
        requestCustomFilterList('create')
      })
  }

  const deleteCustomFilter = (selectedFilter) => {
    if (selectedFilter.filterName !== 'DEFAULT') {
      const obj = {
        filterName: selectedFilter.filterName,
        id: selectedFilter.id,
        idDomain: selectedFilter.idDomain,
        idDomainApplication: selectedFilter.idDomainApplication,
      }
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestDeleteCustomFilter(obj)
        .then(x => x.json())
        .then(res => {
          if (res.ret_code !== 200) {
            mc.error("An error happened, please try again.");
            return;
          }
          mc.success('successfully deleted filter')
          setShowFilter(false)
          setIsAbleDelete(false)
          setFilterSelected(filtersList[0])
          requestCustomFilterList('delete')
        })
    } else {
      mc.error("This filter cannot be removed!")
    }
  }

  const requestCustomFilterList = (action) => {

    const obj = {
      idDomain: 319,
      idDomainApplication: 388
    }

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetCustomFilter(obj)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        const enquiryFilterList = res.ret_value.filter(
          element => {
            return element.idDomain === 319 && element.idDomainApplication === 388
          }
        )
        const option = []
        enquiryFilterList.map((element, index) => {
          let opt = {
            label: element.filterName,
            value: index
          }
          option.push(opt)
        })
        setFilterOptions(option)
        setFiltersList(enquiryFilterList)
        const query = new URLSearchParams(location.search);
        let name = query.get('name')
        let index = option.find(option => option.label === name)?.value
        if (action === 'search' || action === 'load' || name) {
          formik.current?.setFieldValue("filtersList", index);
          const value = {
            filterName: name,
            reference: "",
            client: "",
            obligor: "",
            broker: "",
            status: "",
            endorsementStatus: "",
            idAction: "",
            leadingOffice: "",
            products: "",
            nextPayment: {
              from: undefined,
              to: undefined,
            }
          }
          setFilterSelected(value)
        } if (action === 'create') {
          const filterCreated = option[option.length - 1]
          formik.current?.setFieldValue("filtersList", filterCreated.value);
          const value = {
            filterName: filterCreated.label,
            reference: "",
            client: "",
            obligor: "",
            broker: "",
            status: "",
            endorsementStatus: "",
            idAction: "",
            leadingOffice: "",
            products: "",
            nextPayment: {
              from: undefined,
              to: undefined,
            }
          };
          setFilterSelected(value)
        } if (action === 'load' && !name || action === 'reset') {
          setFilterSelected(enquiryFilterList[0])
          formik.current?.setFieldValue("filtersList", 0);
        }
      })
  }

  async function updateData(item, requireAttention) {
    setData(data.map((policy) => {
      if (item.idOperation == policy.idOperation) {
        policy.requireAttention = requireAttention;
      } else {
        policy.endorsements = policy.endorsements.map((endorsement) => {
          if (item.idOperation == endorsement.idOperation) {
            endorsement.requireAttention = requireAttention;
          }
          return endorsement;
        })
      }
      return policy;
    }))
  }

  async function handleGetNotes(item) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationNotes(item.idOperation)
      .then(response => response.json()).then(data => {
        setNotesModalProps({
          item,
          notes: data.ret_value.notes,
          requireAttention: data.ret_value.requireAttention
        })
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetNotes.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  }

  const handleSubmitNotes = (item, notes, isRequireAttention) => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationNotesUpdateV2(item.idOperation, notes, isRequireAttention)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg);
          loading.stop();
          return;
        }
        handleGetNotes(item)
        loading.stop();
      })
      .catch(() => {
        loading.stop();
      });
  }

  async function requestProductsList() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestProductsList()
      .then(x => x.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }

        const options = response.ret_value
          .map(product => ({
            label: product.PRODUCT_NAME,
            value: product.ID_PRODUCT
          }))
        setProducts(options);
      })
      .catch(error => console.log(error));
  }

  const controlFilter = (action) => {
    if (action === 'edit' && filterSelected.filterName && filterSelected.filterName != 'DEFAULT') {
      setIsAbleEdit(!isAbleEdit)
      setIsAbleDelete(false)
      setIsAbleCreate(false)
    }
    if (action === 'create') {
      setFilterSelected(initialValues.filter)
      setIsAbleEdit(false)
      setIsAbleDelete(false)
      setIsAbleCreate(!isAbleCreate)
    }
    if (action === 'delete') {
      if (filterSelected.filterName === 'DEFAULT') return mc.error('This filter could not be changed.');
      deleteFilter()
    }
  }

  const handleCustomFilter = (value) => {
    if (isAbleEdit) {
      if (!value.filter.name || value.filter.name === 'DEFAULT' || value.filter.name === 'default') {
        return mc.error("An error happened, incorrect value for filter name.");
      }
      setIsAbleEdit(false)
      return editCustomFilter(value)
    }
    if (isAbleCreate) {
      if (!value.filter.name || value.filter.name === 'DEFAULT' || value.filter.name === 'default') {
        return mc.error("An error happened, incorrect value for filter name.");
      }
      setIsAbleCreate(false)
      return createCustomFilter(value)
    }
    if (!isAbleCreate || !isAbleEdit) {
      setShowFilter(false)
      return handleFilter(value)
    }
  };


  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      goToLoginPage();
    } else {
      fitinsur.setAuthToken(authContext.token);
    }

    formik.current?.setFieldValue("endorsements", data);
    if (location.search) {
      handleSetFilterFromParams()
      getList(1, {}, location.search);

    } else {
      handleGetPreviusFilter();
    }

    requestBrokerHeaderList();
    getEndorsementsStatusList();
    requestCustomFilterList('load');
    requestProductsList();

    cache.getTooltip("DOMAINS", region, "357", [585, 586, 587, 588, 601, 581, 598], authContext.token).then(msg => {
      let obj = [];
      msg.map(element => {
        obj[element.MODEL_ITEM_ID] = element.MSG_TEXT;
      })
      setTooltips(obj)
    }).catch(err => console.log("error", err));

  }, []);

  useEffect(() => {
    formik.current?.setFieldValue("endorsements", data);
  }, [data]);

  useEffect(() => {
    handleSetFilterFromParams()
  }, [statusList, endorsementsStatus]);

  const actionOptions = [{ label: 'To Approve', value: 1 }]

  useEffect(() => {
    if(scrollUpdate && !(!data || data.length === 0 || pageNumber === totalPages)){
      if(!loading.active){
        nextPage();
      }
    }
  }, [scrollUpdate])

  return (
    <Layout title={'Policies & Endorsements'}>
      <Content>
        <DialogComponent

          icon={dialog.icon}
          title={dialog.title}
          show={dialog.visible}
          setDialog={setDialog}
        >
          {typeDialog === 'changeBroker'
            ? (
              <ContentAlert>
                <p>You are about to change the broker in this deal, are you sure?</p>
                <DialogCancel
                  onClick={() => {
                    setTypeDialog('')
                    setDialog({
                      visible: false,
                      title: null,
                      icon: null,
                      args: null
                    });
                    setData([])
                    getList(pageNumber || 1, sortBy, location.search)
                  }}
                >
                  Cancel
                </DialogCancel>
                <DialogConfirm onClick={() => {
                  const newBroker = dialog.args.listBrokers.find(broker => broker.value == dialog.args.newValue);

                  const body = {
                    idOperation: dialog.args.idOperation,
                    idPerson: newBroker.value,
                    namePerson: newBroker.label,
                  }

                  fitinsur.setAuthToken(authContext.token);
                  fitinsur.changeBrokerPolicies(body)
                    .then(response => response.json())
                    .then(response => {
                      if (response.ret_code !== 200) {
                        mc.error("An error happened, please try again");
                        return;
                      }
                      setData([]);
                      setDialog({ visible: false, title: null, icon: null, args: null });
                      getList(pageNumber || 1, sortBy, location.search)
                      setTypeDialog('')
                    })
                    .catch(e => {
                      mc.error("An error happened, please try again");
                      return;
                    })
                }}
                >
                  Confirm
                </DialogConfirm>
              </ContentAlert>
            ) : typeDialog === 'deleteFilter'
              ? (
                <>
                  <DialogCancel onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setDialog({ visible: false, title: null, icon: null, args: null })
                  }}>
                    Cancel
                  </DialogCancel>
                  <DialogConfirm onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    deleteCustomFilter(filterSelected);
                    setDialog({ visible: false, title: null, icon: null, args: null })
                  }}>
                    Confirm
                  </DialogConfirm>
                </>
              )
              : (
                <Formik
                  initialValues={{ products: '' }}
                  innerRef={endorsementFormik}
                >
                  <Form>
                    <DialogSelect>
                      <Field
                        name="products"
                        placeholder="Select"
                        component={SelectField}
                        options={endorsementsTypes}
                        onChange={e => setSelectedEndorsmentType(e)}
                      />
                    </DialogSelect>
                    <DialogCancel type="button" onClick={() => {
                      setDialog({ visible: false, title: null, icon: null, args: null })
                      setSelectedEndorsmentType(null)
                      endorsementFormik.current?.setFieldValue('products', '')
                    }}>
                      Cancel
                    </DialogCancel>
                    <DialogConfirm type="button"
                      onClick={ () => endorsementFormik.current?.values.products !== ''
                        ? handleCreateEndorsement()
                        : mc.error(`An endorsement type must be selected.`)
                      }
                    >Confirm</DialogConfirm>
                  </Form>
                </Formik>
              )
          }

        </DialogComponent>
        <Formik
          initialValues={initialValues}
          onSubmit={values => handleFilter(values)}
          innerRef={formik}
        >
          {(formikProps) => (
            <Form style={{ minHeight: showFilter ? '550px' : '' }}>
              <RowFilterIcon>
                <FilterContainer className={showFilter ? 'filter-open' : 'filter-close'}>
                  <Row>
                    <Col style={{ display: "flex", justifyContent: 'flex-end' }}>
                      <Icon name="close" className="icon-close" onClick={() => setShowFilter(false)} />
                    </Col>
                  </Row>

                  <RowFilterOrder>
                    <MobileLabel>
                      ORDER
                    </MobileLabel>
                    <div style={{ display: "flex", flexDirection: "column", padding: "10px" }}>
                      {columnsFilter.map((column, index) =>
                        isClient && column.value === 'client' ? <></> : (
                          <Row key={index}>
                            <GridColumnTitle
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleSortList(column.value)}
                              className="mb-2 mr-2"
                            >
                              {column.title}
                            </GridColumnTitle>
                            {
                              column.value && sortBy.key === column.value && sortBy.direction === "asc" ?
                                <Icon name={"arrowup"} /> :
                                column.value && sortBy.key === column.value && sortBy.direction === "desc" ?
                                  <Icon name={"arrowdown"} /> :
                                  ''
                            }
                          </Row>
                        )
                      )}
                    </div>
                    <Col>
                      <GridColumnTitle>
                        STATUS
                      </GridColumnTitle>
                    </Col>
                    <Col>
                      <GridColumnTitle>
                        ACTION
                      </GridColumnTitle>
                    </Col>
                  </RowFilterOrder>
                  <hr className="d-md-none mb-3" />
                  <FilterSearchContainer>
                    <Row>
                      <Col>
                        <MobileLabel>
                          {filterSelected.filterName ? filterSelected.filterName : 'FILTER'}
                        </MobileLabel>
                      </Col>
                      <Col>
                        <Row>
                          <ColIcon>
                            <Icon
                              name="edit"
                              onClick={() => {
                                controlFilter('edit')
                              }}
                              disabled={true}
                            />
                          </ColIcon>
                          <ColIcon>
                            <Icon
                              name="trash"
                              onClick={() => {
                                formikProps.setValues({
                                  filter: {
                                    id: '',
                                    name: '',
                                    reference: '',
                                    client: '',
                                    obligor: '',
                                    broker: '',
                                    status: '',
                                    endorsementStatus: '',
                                    idAction: '',
                                    leadingOffice: '',
                                    products: '',
                                    nextPayment: {
                                      from: '',
                                      to: '',
                                    }
                                  }
                                })
                                controlFilter('delete')
                              }}
                            />
                          </ColIcon>
                          <ColIcon>
                            <Icon
                              name="add-grey"
                              onClick={() => {
                                formikProps.setValues({
                                  filter: {
                                    id: '',
                                    name: '',
                                    reference: '',
                                    client: '',
                                    obligor: '',
                                    broker: '',
                                    status: '',
                                    endorsementStatus: '',
                                    idAction: '',
                                    leadingOffice: '',
                                    products: '',
                                    nextPayment: {
                                      from: '',
                                      to: '',
                                    }
                                  }
                                })
                                controlFilter('create')
                              }}
                            />
                          </ColIcon>
                        </Row>

                      </Col>
                    </Row>
                    <RowFilter>
                      {isAbleEdit || isAbleCreate ?
                        <FilterColumn>
                          <Field
                            name="filter.name"
                            placeholder="Filter Name"
                            value={formikProps.values.filter.name}
                            component={InputField}
                            type="text"
                            onChange={(e) => {
                              formikProps?.setFieldValue("name", e);
                            }}
                            validation={false}
                            list={true}
                          />
                        </FilterColumn>
                        :
                        <FilterColumn>
                          <Field
                            name="filtersList"
                            label="My filters"
                            isRequired
                            options={filterOptions}
                            onChange={(e) => {
                              let office = {};
                              if (!Array.isArray(filtersList[e].filterArgs.leadingOffice) && filtersList[e].filterArgs.leadingOffice) {
                                office = filtersList[e].filterArgs.leadingOffice.trim();
                                office = offices.find(officeLeading => officeLeading.label == office);
                              } else {
                                office.value = '';
                              }
                              setFilterSelected(filtersList[e])
                              formikProps.setValues({
                                filter: {
                                  id: filtersList[e].id,
                                  name: filtersList[e].filterName,
                                  reference: filtersList[e].filterArgs.reference,
                                  client: filtersList[e].filterArgs.client,
                                  obligor: filtersList[e].filterArgs.obligor,
                                  broker: filtersList[e].filterArgs.broker,
                                  status: filtersList[e].filterArgs.status,
                                  endorsementStatus: filtersList[e].filterArgs.endorsementStatus,
                                  idAction: filtersList[e].filterArgs.idAction,
                                  leadingOffice: filtersList[e].filterArgs.leadingOffice && Array.isArray(filtersList[e].filterArgs.leadingOffice) ? filtersList[e].filterArgs.leadingOffice : office?.value ? [office?.value] : '',
                                  products: filtersList[e].filterArgs.products ? filtersList[e].filterArgs.products : "",
                                  nextPayment: {
                                    from: filtersList[e].filterArgs.nextPayment.from,
                                    to: filtersList[e].filterArgs.nextPayment.to,
                                  }
                                }
                              })
                              formikProps?.setFieldValue("filtersList", filterOptions[e].value);
                            }}
                            component={SelectField}
                          />
                        </FilterColumn>
                      }
                    </RowFilter>
                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps.values.filter.reference.length}
                            onChange={() => formik.current?.setFieldValue('filter.reference', '')}
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name='filter.reference'
                          placeholder='Reference'
                          component={InputField}
                          validation={false}
                          onPressEnter={() => handleFilter()}
                        />
                      </FilterColumn>
                    </RowFilter>

                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps.values.filter.leadingOffice.length}
                            onChange={() => formik.current?.setFieldValue('filter.leadingOffice', '')}
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name='filter.leadingOffice'
                          placeholder='Office'
                          component={MultiSelectField}
                          validation={false}
                          options={offices || []}
                          onPressEnter={() => handleFilter()}
                          format={(value) => {
                            const selectedOffices = offices.filter(option => value.includes(option.value))
                            return selectedOffices.map(item => item.label).join(', ')
                          }}
                          filter={true}
                          onChange={(e) => {
                            if(!e.length){
                              formik.current?.setFieldValue(
                                "filter.leadingOffice",
                                ""
                              )
                            }else{
                              formik.current?.setFieldValue(
                                "filter.leadingOffice",
                                e
                              )
                            }
                          }}
                        />
                      </FilterColumn>
                    </RowFilter>

                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps.values.filter.client.length}
                            onChange={() => formik.current?.setFieldValue('filter.client', '')}
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name='filter.client'
                          placeholder='Client'
                          component={InputField}
                          validation={false}
                          onPressEnter={() => handleFilter()}
                        />
                      </FilterColumn>
                    </RowFilter>
                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps.values.filter.obligor.length}
                            onChange={() => formik.current?.setFieldValue('filter.obligor', '')}
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name='filter.obligor'
                          placeholder='Main Party'
                          component={InputField}
                          validation={false}
                          onPressEnter={() => handleFilter()}
                        />
                      </FilterColumn>
                    </RowFilter>
                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps?.values?.filter?.products?.length}
                            onChange={() => formik.current?.setFieldValue('filter.products', '')}
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name='filter.products'
                          placeholder='Products'
                          component={MultiSelectField}
                          validation={false}
                          options={products || []}
                          onPressEnter={() => handleFilter()}
                          format={(value) => {
                            const selectedProducts = products.filter(option => value.includes(option.value))
                            return selectedProducts.map(item => item.label).join(', ')
                          }}
                          filter={true}
                          onChange={(e) => {
                            if(!e.length){
                              formik.current?.setFieldValue(
                                "filter.products",
                                ""
                              )
                            }else{
                              formik.current?.setFieldValue(
                                "filter.products",
                                e
                              )
                            }
                          }}
                        />
                      </FilterColumn>
                    </RowFilter>
                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps.values.filter.broker.length}
                            onChange={() => formik.current?.setFieldValue('filter.broker', '')}
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name='filter.broker'
                          placeholder='Broker'
                          component={MultiSelectField}
                          options={brokerOptions || []}
                          validation={false}
                          format={(value) => {
                            const selectedBrokers = brokerOptions.filter(option => value.includes(option.value))
                            return selectedBrokers.map(item => item.label).join(', ')
                          }}
                          filter={true}
                          onChange={(e) => {
                            if(!e.length){
                              formik.current?.setFieldValue(
                                "filter.broker",
                                ""
                              )
                            }else{
                              formik.current?.setFieldValue(
                                "filter.broker",
                                e
                              )
                            }
                          }}
                        />
                      </FilterColumn>
                    </RowFilter>
                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps.values.filter.nextPayment.from}
                            onChange={() => formik.current?.setFieldValue('filter.nextPayment', { from: null, to: null })}
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name='filter.nextPayment'
                          placeholder='Next Payment'
                          component={InputField}
                          rightIcon='calendar'
                          rightIconClick={() => { setShowCalendar(!showCalendar) }}
                          validation={false}
                          customValue={showRangeDate()}
                          type="text"
                          readOnly
                        />
                        {showCalendar &&
                          <CalendarContainer>
                            <DateRangePicker
                              initialRange={{
                                from: formikProps.values?.filter?.nextPayment?.from,
                                to: formikProps.values?.filter?.nextPayment?.to,
                              }}
                              onChange={range => {
                                formikProps?.setFieldValue('filter.nextPayment.from', range.from)
                                formikProps?.setFieldValue('filter.nextPayment.to', range.to)

                                if (range.from && range.to) {
                                  setShowCalendar(false)
                                  handleFilter({
                                    nextPaymentFrom: new Date(range.from).toLocaleDateString('en-US'),
                                    nextPaymentTo: new Date(range.to).toLocaleDateString('en-US'),
                                  })
                                }
                              }}
                            />
                          </CalendarContainer>
                        }
                      </FilterColumn>
                    </RowFilter>
                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps.values.filter.status.length}
                            onChange={() => formik.current?.setFieldValue('filter.status', '')}
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name='filter.status'
                          placeholder='Operation'
                          component={MultiSelectField}
                          validation={false}
                          options={statusList}
                          format={(value) => {
                            const selectedBrokers = statusList.filter(option => value.includes(option.value))
                            return selectedBrokers.map(item => item.label).join(', ')
                          }}
                          style={{ width: 'auto', maxWidth: '260px' }}
                          onChange={(e) => {
                            if(!e.length){
                              formik.current?.setFieldValue(
                                "filter.status",
                                ""
                              )
                            }else{
                              formik.current?.setFieldValue(
                                "filter.status",
                                e
                              )
                            }
                          }}
                        />
                      </FilterColumn>
                    </RowFilter>
                    <RowFilter>
                      <CheckBoxColumn>
                        <Label>
                          <Checkbox
                            checked={formikProps.values.filter.endorsementStatus}
                            onChange={() => formik.current?.setFieldValue('filter.endorsementStatus', '')}
                          />
                        </Label>
                      </CheckBoxColumn>
                      <FilterColumn>
                        <Field
                          name='filter.endorsementStatus'
                          placeholder='Status'
                          component={MultiSelectField}
                          validation={false}
                          options={endorsementsStatus}
                          format={(value) => {
                            const selectedEndorsementStatus = endorsementsStatus.filter(option => value.some(status => _.isEqual(status[0], option.value)) || value.includes(option.value))
                            return selectedEndorsementStatus.map(item => item.label).join(', ')
                          }}
                          style={{ width: 'auto', maxWidth: '260px' }}
                          onChange={(e) => {
                            if(!e.length){
                              formik.current?.setFieldValue(
                                "filter.endorsementStatus",
                                ""
                              )
                            }else{
                              formik.current?.setFieldValue(
                                "filter.endorsementStatus",
                                e
                              )
                            }
                          }}
                        />
                      </FilterColumn>
                    </RowFilter>
                    {isClient ? <></> :
                      <RowFilter>
                        <CheckBoxColumn>
                          <Label>
                            <Checkbox
                              checked={formikProps.values.idAction}
                              onChange={() => formik.current?.setFieldValue('idAction', '')}
                            />
                          </Label>
                        </CheckBoxColumn>
                        <FilterColumn>
                          <Field
                            name="idAction"
                            placeholder="Actions"
                            component={SelectField}
                            options={actionOptions}
                            validation={false}
                            value={formikProps.values.idAction}
                            filter={true}
                            onChange={(e) => {
                              formikProps?.setFieldValue('idAction', e);
                              formikProps.submitForm()
                            }}
                            corDiferente={false}
                          />
                        </FilterColumn>
                      </RowFilter>
                    }
                  </FilterSearchContainer>

                  <Row align="center" className='apply-button-container'>
                    <Col>
                      <Button
                        primary
                        type="button"
                        id="btnFilter"
                        style={{ textAlign: "center" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleCustomFilter(formikProps.values);
                        }}
                      >
                        {isAbleEdit || isAbleCreate ? 'Save' : 'Apply'}
                      </Button>
                    </Col>
                  </Row>
                </FilterContainer>

                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <FilterLabel>
                    {filterSelected.filterName ? `FILTER: ${filterSelected.filterName}` : ''}
                  </FilterLabel>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <ColIcon>
                      <Icon
                        name="exportExcel"
                        title="Export Excel"
                        onClick={() => handleExportEndorsements(1, sortBy, location.search || undefined)}
                      />
                    </ColIcon>
                    <TooltipCard>
                      <TooltipText>
                        <ColIcon>
                          <Icon name="filter" onClick={(e) => setShowFilter(!showFilter)} />
                        </ColIcon>
                      </TooltipText>
                      <TooltipBox className={'filter'}>
                        {tooltips[585]}
                      </TooltipBox>
                    </TooltipCard>
                    <TooltipCard>
                      <TooltipText>
                        <ColIcon>
                          <Icon name="filterCan" onClick={() => resetFilters()} />
                        </ColIcon>
                      </TooltipText>
                      <TooltipBox>
                        {tooltips[586]}
                      </TooltipBox>
                    </TooltipCard>
                  </div>
                </div>
              </RowFilterIcon>

              <ResponsiveTable formikRef={formik?.current} columns={columns} data={data} />

            </Form>
          )}
        </Formik>

        <LoadContainer>
          {(!data || data.length === 0 || pageNumber === totalPages)
            ? (
              <Button forth onClick={(e) => e.preventDefault()}>
                NO MORE ITEMS
              </Button>
            ) : (
              <Button forth onClick={() => nextPage()}>
                +LOAD MORE ACCOUNTS
              </Button>
            )}
        </LoadContainer>
        <NotesModalV2
          show={currentOperation}
          handleClose={() => { setCurrentOperation(null) }}
          idOperation={currentOperation}
          label={'Policy notes'}
          onChange={(idOperation, requireAttention) => {
            setData(data.map((policy) => {
              if (idOperation == policy.idOperation) {
                policy.requireAttention = requireAttention;
              } else {
                policy.childrenData = policy.childrenData.map((endorsement) => {
                  if (idOperation == endorsement.idOperation) {
                    endorsement.requireAttention = requireAttention;
                  }
                  return endorsement;
                })
              }
              return policy;
            }))
          }}
        />
      </Content>

      {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
    </Layout>
  );
}
